module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot6-fdc24506a50a1aa46f673e89fd578dba.png";